
<el-col :span="12" :xs="24" :sm="24" :md="12" class="miniroom-warpper">
  <div class="miniroom-container" :class='{ "locked": getRoomIsLock && !getModEdition }' @click="setRoom(room.id)">
    <el-row>
      <el-col :span="14" class="miniroom-desc">
        <div :class='{ "miniroom-title-alone": getModEdition }'>{{ room.name }}</div>
        <div v-if="!getModEdition">{{ getOccupationByServiceAndDayRoom(getSelectedDay, getSelectedMainService,
          room.id)}} / {{ getRoomNbCouverts }} couverts</div>
        <div v-if="!getModEdition">Tables {{ getRoomStartId }} à {{ getRoomNbEndId }}</div>
        <div v-if="!getModEdition">Occupation : {{ getOccupation }} %</div>
        <div v-if="!getModEdition" class="miniroom-lock-container">
          <el-popover placement="top" width="200" v-model="popupValid2" popper-class="popup-delete black-inputs">
            <p>
              Êtes vous sûr de vouloir<br>
              {{ (getRoomIsLock) ? 'ouvrir' : 'fermer' }} la salle
            </p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" class="dark" type="primary" @click.stop="popupValid2 = false">Annuler</el-button>
              <el-button type="primary" size="mini" @click.stop="lockUnlockRoom()">Confirmer</el-button>
            </div>
          </el-popover>
          <div class="miniroom-lock-btn" @click.stop="popupValid2 = true" :class='{ "locked": getRoomIsLock }'></div>
        </div>
      </el-col>
      <el-col :span="10">
        <v-stage class="miniroom-canvas" :config="configMiniStage">
          <v-layer ref="miniLayer" :config="configMiniLayer">
            <mini-table v-for="table in tables" :key="table.id" :table="table"></mini-table>
          </v-layer>
        </v-stage>
      </el-col>
    </el-row>
    <div class="miniroom-services" v-if="!getModEdition">
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="miniroom-service-container">
            <div class="miniroom-service">
              <services-mini :ref="'minis-' + getSelectedMainService + '-' + room.id" :room="room"
                :ms="getSelectedMainService" :date="getSelectedDay"></services-mini>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-if="getRoomIsLock && !getModEdition" class="miniroom-lock-col"></div>
  </div>
</el-col>
